import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription";
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import cpic from "@/assets/images/services/cementitious.jpeg"

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.1 },
};

const CementitiousWaterproofing = () => {
  return (
    <div className=" pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
      <TitleBar title="Cementitious Waterproofing" />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeft
          imageUrl={cpic}
          title="Description"
          content={
            <>
              <span className="span-text">Cementitious waterproofing</span> is a specialized technique that involves the application of cement-based coatings or admixtures to concrete surfaces. This creates a waterproof barrier that protects against moisture, chemicals, and environmental damage.
              It’s the most common method of waterproofing, using cement, sand, and liquid additives. Adding an <span className="span-text">acrylic membrane</span> enhances bonding and durability. This semi-flexible system is ideal for structural waterproofing needs.
            </>
          }
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Applications of Cementitious Waterproofing">
          <Paragraph content="Cementitious waterproofing is commonly used in various construction applications, including:" />
          <CustomLists
            items={[
              ["Basement walls and floors", "Swimming pools", "Roofs and terraces"],
              ["Water tanks", "Bridge decks"],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages of Cementitious Waterproofing">
          <CustomLists
            items={[
              ["Effective in preventing water infiltration", "Durable and long-lasting"],
              ["Can be applied to both new and existing structures", "Cost-effective compared to other methods"],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Types of Cementitious Waterproofing">
          <ListWithDescription
            layout="stacked"
            items={[
              {
                title: "Single-component Cementitious Coating:",
                content: [
                  "Consists of a liquid polymer and a cement base with special additives.",
                  "Designed for application on well-prepared concrete surfaces.",
                ],
              },
              {
                title: "Two-component Cementitious Coating:",
                content: [
                  "Composed of ready-to-use aggregates combined with an acrylic polymer.",
                  "Includes both powder and liquid components for superior bonding.",
                ],
              },
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Cementitious Waterproofing Application Procedure">
          <ListWithDescription
            layout="stacked"
            items={[
              {
                title: "Surface Preparation:",
                content: [
                  "Clean the substrate with a wire brush or pressure washer.",
                  "Repair visible cracks or voids.",
                  "Moisten the surface without over-saturating before application.",
                ],
              },
              {
                title: "Mixing the Product:",
                content: [
                  "Follow manufacturer instructions for single or two-component systems.",
                  "Mix thoroughly until a smooth, lump-free consistency is achieved.",
                ],
              },
              {
                title: "First Coat Application:",
                content: [
                  "Apply using a brush, roller, or trowel in a single direction.",
                  "Maintain 1–2 mm thickness. Let cure for 4–6 hours.",
                ],
              },
              {
                title: "Second Coat Application:",
                content: ["Apply perpendicular to the first coat to ensure full coverage."],
              },
              {
                title: "Curing:",
                content: [
                  "Keep the coating moist for 2–3 days after application.",
                  "Allow at least 7 days of full curing before exposure to water or load.",
                ],
              },
            ]}
          />
          <div className="py-4">
            <Paragraph content="In conclusion, cementitious waterproofing is a reliable solution for protecting structures from water ingress across a range of applications." />
          </div>
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Why Choose Us for Cementitious Waterproofing?">
          <Paragraph
            content={
              <>
                At <span className="span-text">Sheel Waterproofing</span>, we specialize in high-performance cementitious waterproofing solutions that offer long-term, cost-effective protection for foundations, wet areas, and concrete surfaces. We focus on quality and results, offering:
              </>
            }
          />
          <CustomLists
            listStyle="none"
            layout="stacked"
            items={[[
              "Reliable waterproofing for areas such as bathrooms, basements, and water tanks",
              "Expert surface preparation with superior adhesion to masonry substrates",
              "Professional application by skilled technicians adhering to industry best practices",
              "Cost-effective and proven durable waterproofing solutions",
            ]]}
            bullets={[["🏗️", "🧱", "🧰", "💰"]]}
          />
          <Paragraph
            content={
              <>
                Our systems are ideal for structures where strength and durability are critical. Trust <span className="span-text">Sheel Waterproofing</span> for solutions that deliver performance and peace of mind.
                <br /><br />
                <a href="/contact" className="text-custom-hov underline">Contact us today</a> for a free consultation or site inspection.
              </>
            }
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default CementitiousWaterproofing;
